import { MonitorBase } from './_MonitorBase';

export class MonitorAudio extends MonitorBase {
  constructor(game, parent, config) {
    super(game, parent, { label: 'audio', ...config });

    this.game.events.on(Phaser.Core.Events.POST_RENDER, this.updateMonitor, this);
    this.updateMonitor();
  }

  shutdown() {
    this.game.events.off(Phaser.Core.Events.POST_RENDER, this.updateMonitor, this);
  }

  formatTime(seconds) {
    let minutes = Math.floor(seconds / 60);
    seconds = Math.round(seconds % 60);
    if (minutes >= 1) {
      return `${minutes}m${seconds < 10 ? '0' : ''}${seconds}s`;
    } else {
      return `${seconds}s`;
    }
  }

  updateMonitor() {
    this._audioAudit = {};
    this._audioAudit.totalDuration = 0;
    this._audioAudit.audio = [];
    this.game.cache.audio.entries.each((key, audio) => {
      this._audioAudit.totalDuration += audio.duration;
      this._audioAudit.audio.push({
        key,
        duration: audio.duration,
      });
    });
    let audioString = `Cache : ${this.formatTime(this._audioAudit.totalDuration)}`;
    audioString += `, Playing : ${this.game.sound.sounds.length}`;
    this.setValue(audioString);
  }

  getLog() {
    let str = '';
    str += `\nTotal Audio\t\t: ${this._audioAudit.audio.length}`;
    str += `\nTotal Duration\t: ${this.formatTime(this._audioAudit.totalDuration)}`;
    str += `\nPlaying\t: ${this.game.sound.sounds.length}`;
    str += `\nAudio in Cache\t:`;

    this._audioAudit.audio.forEach((audio) => {
      str += `\n\t${audio.key}`;
      str += `\n\t\tduration : ${this.formatTime(audio.duration)}`;
    });
    return str;
  }
}
